import { render, staticRenderFns } from "./OrderListItem.vue?vue&type=template&id=2a918b9c&scoped=true&"
import script from "./OrderListItem.vue?vue&type=script&lang=ts&"
export * from "./OrderListItem.vue?vue&type=script&lang=ts&"
import style0 from "./OrderListItem.vue?vue&type=style&index=0&id=2a918b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a918b9c",
  null
  
)

export default component.exports